export enum CombinedEmployeeSearchType {
  Country = 10,
  BusinessUnit = 20,
  Grade = 30,
  Position = 40,
  Employee = 50,
  DistributionLists = 60
}
